// extracted by mini-css-extract-plugin
module.exports = {"btnMore":"DepositMenuActions_btnMore__xhwOo","margin-with":"DepositMenuActions_margin-with__hY6fZ"};